import { Formsy, george, observable, observer, React, RouteComponentProps, ui } from "aaa";
import { pushRoute } from "stores/RouterFunctions";
import { amountToCurrencyString, amountToNumber, ZERO_AMOUNT } from "types/amount";
import { isNumber, localizedNumber, maxDecimal } from "util/formValidations";
import { ChooseAccount } from "../common/ChooseAccount";
import { QuickDrawdownStore } from "./QuickDrawdownStore";

type IProps = RouteComponentProps<{}> & {
    store: QuickDrawdownStore
};

@observer
export class QuickDrawdownConfiguration extends React.Component<IProps, {}> {
    @observable formsyValid = false;

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    onSubmit = async (values: any) => {
        this.props.store.amount = localizedNumber(values.amount);

        try {
            await this.props.store.transfer();
            pushRoute("/quick-drawdown/signing");
        } catch (error) {
            pushRoute("/quick-drawdown/error");
        }
    }

    render() {
        const maxAmount = this.props.store.cardStore?.card?.availableAmounts?.availableDailyPOSPurchase ?? ZERO_AMOUNT;

        return (
            <george.Background>
                <george.PageWithActionButton>
                    <Formsy.Form
                        onValid={() => this.formsyValid = true}
                        onInvalid={() => this.formsyValid = false}
                        onValidSubmit={this.onSubmit}
                    >
                        {!this.props.store.isLoading() &&
                            <div>
                                <ChooseAccount
                                    store={this.props.store.accountsStore}
                                    title={ui.__("common.recipientAccount")}
                                />

                                <george.Card>
                                    <george.CardSectionTitle title={ui.__("quickDrawdown.amount.title")} />
                                    <george.CardSectionContent>
                                        <george.SectionSubtitleTop>
                                            {ui.__("quickDrawdown.amount.info")}
                                        </george.SectionSubtitleTop>
                                        <george.TextFieldFormsy
                                            name="amount"
                                            required
                                            validations={`isInRange:[0,${amountToNumber(maxAmount)}]`}
                                            // inputValidations={[isNumber, maxDecimal(2)]}
                                            validationError={ui.__("quickDrawdown.amount.tooHigh", { maxAmount: amountToCurrencyString(maxAmount) })}
                                            centered
                                            decorator="EUR"
                                            instantError
                                            aria-label={ui.__("common.amount.euro")}
                                            inputMode="decimal"
                                        />
                                    </george.CardSectionContent>
                                </george.Card>
                            </div>
                        }

                        <george.LoadingIndicator isLoading={this.props.store.isLoading()} height={ui.windowHeight} />
                        <george.ActionButton
                            messageId="button.continue"
                            disableButton={!this.formsyValid}
                            isLoading={this.props.store.isLoading()}
                            submit
                            onClick={() => {/* use this, if not using formsy */ }}
                        />
                    </Formsy.Form>
                </george.PageWithActionButton>
            </george.Background>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/quickDrawdown/QuickDrawdownConfiguration.tsx